import { customFormat, parseCalendarDate } from 'utils/dateUtils'

export const HEALTH_RANK_UI = {
  on_track: 'onTrack',
  at_risk: 'atRisk',
  off_track: 'offTrack',
  not_rated_yet: 'notRatedYet',
  not_rated_small: 'notRatedSmall',
}

export const HEALTH_LABEL = {
  onTrack: 'On track',
  atRisk: 'At risk',
  offTrack: 'Off track',
  notRatedYet: 'Not rated yet',
  notRatedSmall: 'Not rated',
}

const HEALTH_DATE_FORMAT = 'd MMM yyyy'

const EMPTY_HEALTH = {
  available: false,
  health: null,
  assigned: null,
  extendedTo: null,
  extendedCount: 0,
}

export const formatHealthDate = (isoDate) => {
  const date = parseCalendarDate(isoDate)
  if (!date) {
    return null
  }

  return customFormat(date, HEALTH_DATE_FORMAT)
}

export const adaptCampaignHealth = (payload) => {
  if (!payload?.available) {
    return EMPTY_HEALTH
  }

  const rank = HEALTH_RANK_UI[payload.rank] || 'atRisk'

  return {
    available: true,
    health: {
      rank,
      label: HEALTH_LABEL[rank],
      daysLeft: payload.daysLeft,
    },
    assigned: payload.assigned,
    extendedTo: formatHealthDate(payload.extendedUntil),
    extendedCount: payload.extendedCount || 0,
  }
}
